export default ['paying', 'medium-delay', 'high-delay', 'paid', 'sold', 'for-transfer'];
